<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="160px">
      <el-form-item label="键值" prop="identityKey">
        <el-input v-model="dataForm.identityKey" placeholder="键值"></el-input>
      </el-form-item>
      <el-form-item label="默认值" prop="content">
        <el-input v-model="dataForm.content" placeholder="默认值"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        visible: false,
        dataForm: {
          id: '',
          identityKey: '',
          content: '',
        }
      }
    },
    methods: {
      init(id) {
        this.dataForm.id = id || ''
        this.visible = true
        if (this.dataForm.id) {
          this.$http({
            url: '/sys/defaultvalue/get?id=' + this.dataForm.id,
            method: 'get'
          }).then(({data}) => {
            if (data && data.code === '1') {
              this.dataForm.id = data.data.id
              this.dataForm.identityKey = data.data.identityKey
              this.dataForm.content = data.data.content
            }
          })
        }
      },
      // 表单提交
      dataFormSubmit() {
        console.log(this.dataForm)
        this.$http({
          url: '/sys/defaultvalue/save',
          method: 'post',
          data: this.dataForm
        }).then(({data}) => {
          if (data && data.code === '1') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    }
  }
</script>
